var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2663_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.215 16.7424C33.0158 16.5771 32.7622 16.4863 32.5 16.4863C32.2378 16.4863 31.9842 16.5771 31.785 16.7424L16 29.8624V45.2864C16 46.1351 16.3477 46.949 16.9665 47.5491C17.5854 48.1493 18.4248 48.4864 19.3 48.4864H28.1C28.3917 48.4864 28.6715 48.374 28.8778 48.174C29.0841 47.9739 29.2 47.7026 29.2 47.4197V41.0197C29.2 40.171 29.5477 39.3571 30.1665 38.757C30.7854 38.1569 31.6248 37.8197 32.5 37.8197C33.3752 37.8197 34.2146 38.1569 34.8335 38.757C35.4523 39.3571 35.8 40.171 35.8 41.0197V47.4197C35.8 47.7026 35.9159 47.9739 36.1222 48.174C36.3285 48.374 36.6083 48.4864 36.9 48.4864H45.7C46.5752 48.4864 47.4146 48.1493 48.0335 47.5491C48.6523 46.949 49 46.1351 49 45.2864V29.8624L33.215 16.7424Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2663_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 32,
    fill: "white",
    transform: "translate(16 16.4863)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.20aed66342df6516dc9e1d9b4f53ee62.svg";
export { ForwardRef as ReactComponent };